import { Url } from '../shared/Url';
import Post from '../shared/Post';


export const SendForgotMail = (usuario, respuesta) => {
    let Content = {
        id: usuario
    }

    Post(`${Url}iForgotPass`, Content, (resp) => {
        let data = JSON.parse(resp);
        respuesta(data)
    });
}

export const CheckToken = (token, respuesta) => {
    let Content = {
        token: token.token_id
    }
    Post(`${Url}verifyTokenForgot`, Content, (resp) => {
        let data = JSON.parse(resp);
        respuesta(data)
    });
}

export const ChangePassW = (token, pass, respuesta) => {
    let Content = {
        token: token,
        pass: pass
    }
    Post(`${Url}changePass`, Content, (resp) => {
        let data = JSON.parse(resp);
        respuesta(data)
    });
}


// WEBPACK FOOTER //
// ./src/funciones/ForgotFunction.jsx